import React from 'react';
import Icon from '../../../components/AppIcon';

const statusConfig = {
  pending: { label: 'در انتظار پرداخت بیعانه', color: 'bg-warning/10 text-warning border-warning/20', icon: 'Clock' },
  review: { label: 'در انتظار بررسی رسید', color: 'bg-blue-500/10 text-blue-500 border-blue-500/20', icon: 'Eye' },
  confirmed: { label: 'تأیید شده', color: 'bg-success/10 text-success border-success/20', icon: 'CheckCircle2' },
  cancelled: { label: 'لغو شده', color: 'bg-error/10 text-error border-error/20', icon: 'XCircle' },
  paid: { label: 'پرداخت کامل شده', color: 'bg-success/10 text-success border-success/20', icon: 'CreditCard' },
  expired: { label: 'منقضی شده (عدم پرداخت)', color: 'bg-error/10 text-error border-error/20', icon: 'AlertTriangle' },
  done: { label: 'انجام شده', color: 'bg-muted text-muted-foreground border-border', icon: 'Check' },
  noShow: { label: 'عدم حضور مشتری', color: 'bg-error/10 text-error border-error/20', icon: 'UserX' },
  inProgress: { label: 'در حال انجام', color: 'bg-primary/10 text-primary border-primary/20', icon: 'Loader2' },
};

const BookingStatusBadge = ({ status }) => {
  const config = statusConfig[status] || { label: 'نامشخص', color: 'bg-muted text-muted-foreground border-border', icon: 'HelpCircle' };

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${config.color}`} dir="rtl">
      <Icon name={config.icon} size={14} />
      <span>{config.label}</span>
    </span>
  );
};

export default BookingStatusBadge;
export { statusConfig };
